import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ErrorService } from '@ninety/platform/services/services/error.service';

import { BaseEffects } from '../../base.effects';
import { NOTIFY_CONTROL } from '../../tokens/notify-control.token';

import { NotificationActions } from './notification.actions';

@Injectable()
export class NotificationStateEffects extends BaseEffects {
  private readonly errorService = inject(ErrorService);
  private readonly notifyService = inject(NOTIFY_CONTROL);
  private readonly snackbar = inject(MatSnackBar);

  notify$ = this.tapEffect({
    action: NotificationActions.notify,
    tapFn: action => this.notifyService.notify(action.message, action.duration, action.action),
  });

  notifyV2$ = this.tapEffect({
    action: NotificationActions.notifyV2,
    tapFn: action => this.notifyService.notifyV2(action.message, action.params),
  });

  notifyError$ = this.tapEffect({
    action: NotificationActions.notifyError,
    tapFn: action => this.errorService.notify(action.error, action.message),
  });

  showError$ = this.tapEffect({
    action: NotificationActions.showError,
    tapFn: action => this.notifyService.showError(action.message, action.title, action.override),
  });

  success$ = this.tapEffect({
    action: NotificationActions.success,
    tapFn: action => this.notifyService.success(action.message, action.title, action.override),
  });

  notifyWithTemplate$ = this.tapEffect({
    action: NotificationActions.notifyWithTemplate,
    tapFn: ({ templateType, data }) => {
      this.notifyService.notifyWithTemplate(templateType, data, 5000);
    },
  });

  showSnackbar = this.tapEffect({
    action: NotificationActions.showSnackbar,
    tapFn: ({ message, duration }) => this.snackbar.open(message, undefined, { duration: duration ? duration : 3000 }),
  });

  showToastError = this.tapEffect({
    action: NotificationActions.showErrorToast,
    tapFn: ({ message }) => this.notifyService.toast(message, null, null, 'negative'),
  });

  showToastSuccess = this.tapEffect({
    action: NotificationActions.showSuccessToast,
    tapFn: ({ message }) => this.notifyService.success(message, null, null),
  });
}
